import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ReactNode } from "react";

export type AppDialogProps = Omit<DialogProps, "title"> & {
  title?: ReactNode;
  actions?: ReactNode;
  /** When false, omit the DialogTitle shell. */
  showTitle?: boolean;
  contentDividers?: boolean;
};

export function AppDialog({
  title,
  actions,
  children,
  showTitle = true,
  contentDividers = false,
  maxWidth = "sm",
  fullWidth = true,
  ...props
}: AppDialogProps) {
  return (
    <Dialog maxWidth={maxWidth} fullWidth={fullWidth} {...props}>
      {showTitle && title != null && <DialogTitle>{title}</DialogTitle>}
      <DialogContent dividers={contentDividers}>{children}</DialogContent>
      {actions != null && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}

export default AppDialog;
